import { render, staticRenderFns } from "./paypal.vue?vue&type=template&id=2c2db7d7"
import script from "./paypal.vue?vue&type=script&lang=js"
export * from "./paypal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports